import { IRootState } from '../../../../store'
import { IHospitalNotifyState } from '../store/hospitalNotify.types'

export const getHospitalNotifySelector = (state: IRootState): IHospitalNotifyState => state.hospitalNotify
